import React, { useState, useEffect, useRef } from "react";

import queryString from 'query-string';
import { Form, Progress, Alert } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo-virtual.png';

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'ctc';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-ctc-container" ref={nodeRef}>
        <img src={logo} alt="logo" className="logo-ctc rounded mx-auto d-block" />
        <Form onSubmit={event => onSubmit(event)}>
          <input
            className="user-input-ctc"
            disabled={onLogin}
            required={true}
            tabIndex={1}
            type="text"
            autoCorrect="off"
            autoCapitalize="none"
            id="username"
            placeholder={translate("PlaceholderUserName")}
            onChange={e => setUsername(e.target.value)}
          />
          <input
            className="user-input-ctc"
            required={true}
            disabled={onLogin}
            tabIndex={1}
            type="password"
            autoCorrect="off"
            autoCapitalize="none"
            id="password"
            placeholder={translate("PlaceholderPassword")}
            onChange={e => setPassword(e.target.value)}
          />
          <div>
            {!onLogin ?
              <button
                block={!parameters.failureRedirect}
                tabIndex={1}
                className="enter-ctc"
                type="submit"
                name="submit"
                disabled={!props.turnstileSuccess}
              >
                {translate('ButtonEnter')}
              </button> :
              <Progress animated color="danger" value={100} />}
          </div>
          <div className="messages-container">
            <Alert color="danger" id="error-message" isOpen={error.open} toggle={() => setError({ error: { open: false } })}>
              {error.message}
            </Alert>
          </div>
          <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
        </Form>

      </div>
    </CSSTransition>
  );
}


export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
